import React, { useCallback, useEffect, useState } from "react";
import { getStandardCourseAhaProductLinks } from "../../../api/backend";
import AhaCatalogView from "../AhaCatalogView";
import { Notice } from "../ui/AdminUi";
import AddProductDialog from "./AddProductDialog";
import { CreateFromProductDialog, LinkCourseDialog } from "./CatalogDialogs";
import "./integrations/integrations.css";

/**
 * The AHA catalog inside Standard courses. The catalog itself (verify, activate, edit, modules) is unchanged; this adds the
 * course each product belongs to, and the two ways to give a product a course.
 */
export default function CatalogTab({ onOpenCourse, addProductSignal }) {
  const [links, setLinks] = useState(null);
  const [createFor, setCreateFor] = useState(null);
  const [linkFor, setLinkFor] = useState(null);
  const [notice, setNotice] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const loadLinks = useCallback(() => getStandardCourseAhaProductLinks()
    .then((map) => setLinks(map || {}))
    .catch(() => setLinks({})), []);

  useEffect(() => { loadLinks(); }, [loadLinks]);

  const done = (courseId, message, open) => {
    setCreateFor(null);
    setLinkFor(null);
    setNotice(message);
    loadLinks();
    setReloadKey((k) => k + 1);
    if (open) onOpenCourse(courseId, "integrations");
  };

  if (links === null) return <div data-testid="catalog-tab" />;

  return (
    <div data-testid="catalog-tab">
      {notice && <div style={{ marginBottom: 14 }}><Notice kind="ok">{notice} <button type="button" className="b ghost sm" onClick={() => setNotice(null)}>Dismiss</button></Notice></div>}
      <AhaCatalogView
        courseLinks={links}
        reloadKey={reloadKey}
        addProductSignal={addProductSignal}
        AddDialog={AddProductDialog}
        onProductAdded={(message) => { setNotice(message); loadLinks(); }}
        onOpenCourse={(course) => onOpenCourse(course.id, "integrations")}
        onCreateCourse={setCreateFor}
        onLinkCourse={setLinkFor}
      />
      {createFor && <CreateFromProductDialog product={createFor} onClose={() => setCreateFor(null)} onDone={(id, msg) => done(id, msg, true)} />}
      {linkFor && <LinkCourseDialog product={linkFor} onClose={() => setLinkFor(null)} onDone={(id, msg) => done(id, msg, false)} />}
    </div>
  );
}
